import '../../Styles/RightSidePanel.scss';
function RightSidePanel() {
  return (
    <div className="RightSidePanel">
        <div className='EmailBox'>
         <a href="mailto:parmanandchared1997@gmail.com" className="Email_Lines">parmanandchared1997@gmail.com</a>
        </div>
    </div>
  );
}

export default RightSidePanel;
